import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./locales/ar.json";
import az from "./locales/az.json";
import bg from "./locales/bg.json";
import cs from "./locales/cs.json";
import da from "./locales/da.json";
import de from "./locales/de.json";
import el from "./locales/el.json";
import enIn from "./locales/en-in.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fa from "./locales/fa.json";
import fil from "./locales/fil.json";
import fr from "./locales/fr.json";
import hu from "./locales/hu.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import kk from "./locales/kk.json";
import ko from "./locales/ko.json";
import lo from "./locales/lo.json";
import lv from "./locales/lv.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ro from "./locales/ro.json";
import ru from "./locales/ru.json";
import si from "./locales/si.json";
import sk from "./locales/sk.json";
import sl from "./locales/sl.json";
import sv from "./locales/sv.json";
import tr from "./locales/tr.json";
import uk from "./locales/uk.json";
import vi from "./locales/vi.json";
import zhHk from "./locales/zh-hk.json";
import zhTw from "./locales/zh-tw.json";
import zh from "./locales/zh.json";

// Get language from localStorage or browser, default to English
const getInitialLanguage = () => {
  const url = new URL(window.location.href);
  const language =
    url.searchParams.get("lang") || url.searchParams.get("language");
  if (language) {
    return language;
  }

  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage) {
    return savedLanguage;
  }

  return "en";
};

const messages = {
  // Arabic
  "ar-AE": ar,
  // Azerbaijani
  "az-AZ": az,
  // Bulgarian
  "bg-BG": bg,
  // Czech
  "cs-CZ": cs,
  // Danish
  "da-DK": da,
  // German
  "de-DE": de,
  // Greek
  "el-GR": el,
  // English
  "en-GB": en,
  "en-IN": enIn,
  "en-TR": en,
  "en-US": en,
  // Spanish
  "es-ES": es,
  // Persian
  "fa-IR": fa,
  // Filipino
  "fil-PH": fil,
  // French
  "fr-FR": fr,
  // Hungarian
  "hu-HU": hu,
  // Indonesian
  "id-ID": id,
  // Italian
  "it-IT": it,
  // Japanese
  "ja-JP": ja,
  // Kazakh
  "kk-KZ": kk,
  // Korean
  "ko-KR": ko,
  // Lao
  "lo-LA": lo,
  // Latvian
  "lv-LV": lv,
  // Dutch
  "nl-NL": nl,
  // Polish
  "pl-PL": pl,
  // Portuguese
  "pt-BR": pt,
  "pt-PT": pt,
  // Romanian
  "ro-RO": ro,
  // Russian
  "ru-RU": ru,
  // Sinhala
  "si-LK": si,
  // Slovak
  "sk-SK": sk,
  // Slovenian
  "sl-SI": sl,
  // Swedish
  "sv-SE": sv,
  // Turkish
  "tr-CT": tr,
  "tr-TR": tr,
  // Ukrainian
  "uk-UA": uk,
  // Vietnamese
  "vi-VN": vi,
  // Chinese
  "zh-MY": zh,
  "zh-TW": zhTw,
  // Backward compatibility - keep old keys for existing code
  en: en,
  "en-in": enIn,
  zh: zh,
  "zh-tw": zhTw,
  "zh-hk": zhHk,
  "zh-HK": zhHk,
  vi: vi,
  id: id,
  ru: ru,
  ja: ja,
  ko: ko,
  tr: tr,
  pt: pt,
  es: es,
  de: de,
  it: it,
  fil: fil,
  fa: fa,
  ar: ar,
  uk: uk,
  fr: fr,
  az: az,
  bg: bg,
  cs: cs,
  da: da,
  el: el,
  hu: hu,
  kk: kk,
  lo: lo,
  lv: lv,
  nl: nl,
  pl: pl,
  ro: ro,
  si: si,
  sk: sk,
  sv: sv,
  sl: sl,
};

i18n.use(initReactI18next).init({
  resources: Object.entries(messages).reduce((acc, [key, value]) => {
    acc[key] = { translation: value };
    return acc;
  }, {} as Record<string, { translation: typeof en }>),
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
